import React from 'react';
import { Hero } from './components/Hero';
import { SystemSection } from './components/SystemSection';
import { PagePreviewSection } from './components/PagePreviewSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink font-sans text-ivory" data-id="element-0" data-mp="28sl32w6ujkeg">
      <Hero data-id="element-1" data-mp="23vulg4fe8gqx" />
      <main data-id="element-2" data-mp="23u9uspw79hyc">
        <SystemSection data-id="element-3" data-mp="23ujha3i1d6za" />
        <PagePreviewSection data-id="element-4" data-mp="23t8g8bfz6dbv" />
        <VolumesSection data-id="element-5" data-mp="3ik7ekc2063oj" />
        <BonusSection data-id="element-6" data-mp="3iiweonbohg2p" />
        <TransformationSection data-id="element-7" data-mp="3ijfthv617oci" />
        <TestimonialsSection data-id="element-8" data-mp="3mljat0fdtn5p" />
        <OfferSection data-id="element-9" data-mp="3mkrbpfmkt7ao" />
        <FaqSection data-id="element-10" data-mp="3mk83wrqn3zad" />
        <FinalCtaSection data-id="element-11" data-mp="3mjgannkimdn9" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3rbra6pbcfxfa" />
      <PurchaseNotifications data-id="element-13" data-mp="3rdaq2et386gj" />
    </div>;
}